module.exports = __webpack_public_path__ + "img/FR12006.25e2a62f.png";